/**
 * Server-side "onboarding completed" proxy shared by the routing guards
 * (SchoolRoutes' onboarding/dashboard guards and Dashboard's own check).
 *
 * `OnboardingWizard.tutorial.dashboard === false` is written by the wizard's completion
 * path, so its presence means "completed at least once". On its own that over-claims for
 * schools whose completion came from the auto-seeded SAMPLE run: clearing sample data is
 * supposed to reset the flag to `true` (see buildPostSampleDeletePreferences), but a clear
 * done on an older build — or one whose preferences PUT failed — leaves the stale `false`
 * behind while the school restarts with actual data. The new run's resume pointer then
 * says mid-flow (e.g. frequency, review) while the flag still says done, and the guards
 * bounce the tenant — and anyone impersonating them — to the dashboard, locking them out
 * of /onboarding entirely.
 *
 * A mid-flow pointer with sample data inactive is proof of an unfinished actual-data run,
 * so it outranks the stale flag. A pointer at `summary` (where the completion CTAs live)
 * or an active sample workspace still counts as complete.
 */
export const isOnboardingCompleteFromPreferences = (
  preferences: {[key: string]: any} | null | undefined
): boolean => {
  const wizard = preferences?.OnboardingWizard
  if (wizard?.tutorial?.dashboard !== false) return false
  const stepSlug = wizard?.progress?.stepSlug
  const midActualDataRun =
    Boolean(stepSlug) && stepSlug !== 'summary' && wizard?.sampleData?.active !== true
  return !midActualDataRun
}
